if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	window.dispatchEvent(new CustomEvent("onBeforeInject",{detail:{link:linkTag}}))
	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"runtime": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"vendors-node_modules_zoho_lyte-ui-plugins_plugins_lyte-sortable_js-node_modules_gridstack_dis-5a5ca2":1,"asset_customreports_custom-reports_js-asset_timelogs_timelog-util_js":1,"css/styles/themes/light/ltr/zp-lyte-globalvariables-74e6f72-bundle":1,"css/styles/themes/light/rtl/zp-lyte-globalvariables-74e6f72-bundle":1,"css/styles/themes/light/ltr/zp-lyte-calendar-8862d31-bundle":1,"css/styles/themes/light/rtl/zp-lyte-calendar-962a575-bundle":1,"css/styles/themes/light/ltr/zp-lyte-timepicker-b21cfdc-bundle":1,"css/styles/themes/light/rtl/zp-lyte-timepicker-355fed8-bundle":1,"css/styles/themes/light/ltr/zp-lyte-popover-41548f2-bundle":1,"css/styles/themes/light/rtl/zp-lyte-popover-3668761-bundle":1,"css/styles/themes/light/ltr/zp-lyte-table-a0d33ea-bundle":1,"css/styles/themes/light/rtl/zp-lyte-table-a0d33ea-bundle":1,"router/routes/setup":1,"router/routes/setup/modules":1,"router/routes/setup/server-scripts/credits":1,"asset_accessibility_modules_focus-ring_js":1,"css/styles/themes/light/ltr/zp-lyte-colorpicker-1179a5d-bundle":1,"css/styles/themes/light/rtl/zp-lyte-colorpicker-6b5368a-bundle":1,"asset_interactive-pagetour_interactive-pagetour-manager_js":1,"css/styles/themes/light/ltr/zp-lyte-hovercard-8349eef-bundle":1,"css/styles/themes/light/rtl/zp-lyte-hovercard-8349eef-bundle":1,"components/integrations/server-scripts/script-form/s-script-create-edit-form":1,"components/timelogs/grid-skeleton/grid-skeleton":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr

// no prefetching

// no preloaded